import { render } from "./NonContactDelivery.vue?vue&type=template&id=0a978594"
import script from "./NonContactDelivery.vue?vue&type=script&lang=js"
export * from "./NonContactDelivery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__